import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";
import { fmtCurrency, fmtDate } from "@/lib/format";

export default function Payments() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/customer/payments").then((r) => setItems(r.data)); }, []);

  const paid = items.reduce((a, b) => a + (b.amount || 0), 0);

  return (
    <div className="space-y-8" data-testid="customer-payments-page">
      <PageHeader eyebrow="History" title="Paid details" description="Payments recorded by your developer on your account." />

      <div className="grid-surface p-5 border-l-4 border-l-green-600">
        <div className="overline text-stone-500">Total paid to date</div>
        <div className="font-display text-4xl font-black mt-1">{fmtCurrency(paid)}</div>
        <div className="text-xs text-stone-500 font-mono mt-1">{items.length} payment(s)</div>
      </div>

      <DataTable
        testId="my-payments-table"
        columns={[
          { key: "paid_on", label: "Paid On", render: (r) => fmtDate(r.paid_on) },
          { key: "unit", label: "Unit", render: (r) => <span className="font-mono">{r.unit?.unit_no || "—"}</span> },
          { key: "amount", label: "Amount", render: (r) => <span className="font-mono">{fmtCurrency(r.amount)}</span> },
          { key: "method", label: "Method" },
          { key: "reference", label: "Ref #", render: (r) => <span className="font-mono text-xs">{r.reference || "—"}</span> },
          { key: "notes", label: "Notes" },
        ]}
        rows={items}
        empty="No payments yet."
      />
    </div>
  );
}
